const e = { core: { error: { conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!", internal_error_message: "Something went wrong. Please try again", maintenance_error: "We're currently undergoing scheduled maintenance. This action is temporarily unavailable. Please try again in a few minutes. Thank you for your patience", payload_to_large_error_message: "The file size is too big" } }, global: { error: "Error", errors: { fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue" } } }, r = {
  frontend_utils: e
};
export {
  r as default,
  e as frontend_utils
};
